import type { UserFlag } from "@/services/user/settings/flags/types";
import { type UserSettings } from "./types";

/** @throws {Error} When user flags are not unique */
export const assertUserFlagsAreUnique = (userFlags: UserFlag[]): void => {
  if (new Set(userFlags).size !== userFlags.length) {
    throw new Error("User flags must be unique.");
  }
};

export function assertUserHasSettings(settings: UserSettings | undefined): asserts settings is UserSettings {
  if (settings === undefined) {
    throw new Error("User has no settings (maybe collector not established yet)?");
  }
}
